import axiosInstance from '../axios/axios-instance';
import { PerformanceSetting } from 'shared/enums/performance-setting/performance-setting.enum';

export const performanceSettingsApi = {
  /**
   * Get the performance settings for the current user.
   * @returns The user performance settings.
   */
  async getPerformanceSettings(): Promise<Record<PerformanceSetting, string>> {
    const response = await axiosInstance.get('/performance-settings');
    return response.data as Record<PerformanceSetting, string>;
  },
};
